import FormBuilderConfig from "../../../toolkit/baseForms2/formBuilder/FormBuilder.config";
import IButtonBuilder from "../../../toolkit/baseForms2/iButtonBuilder/IButtonBuilder";
import IUserSelectorBuilder from "../../../toolkit/baseForms2Commons/iUserSelectorBuilder/IUserSelectorBuilder";

export type Inputs = "empleado" | "periodo";
export type Buttons = "aceptar";

export const formConfig: FormBuilderConfig<Inputs, Buttons> = {
  inputs: [
    {
      name: "empleado",
      label: "* Empleado",
      bts: {
        sCol: 8
      },
      component: IUserSelectorBuilder
    },
    {
      name: "periodo",
      label: "* Fecha de Pago",
      bts: {
        sCol: 2
      }
    }
  ],
  buttons: [
    {
      name: "aceptar",
      label: "Buscar",
      isSubmit: true,
      bts: {
        sCol: 2
      },
      component: IButtonBuilder
    }
  ],
  validations: {
    empleado: {
      required: {
        validator: value => !value,
        message: () => "Seleccione un empleado"
      }
    },
    periodo: {
      required: {
        validator: value => !value,
        message: () => "Seleccione un periodo"
      }
    }
  },
  rows: [["empleado", "periodo", "aceptar"]]
};
